import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Checkbox, RadioButton, RadioButtonGroup } from 'carbon-components-react';
import { Card } from '../../../components';
import { insertDmService } from '../../../services/Api';

class NewCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      sms: 0,
      push: 0
      // error: null,
    };
  }

  // Método modificado para garantir que apenas um checkbox esteja ativo
  onChangeCheck = (val, id, event) => {
    const { name } = event.target;
    
    if (val) {
      // Se estiver marcando um checkbox, desmarca o outro
      if (name === 'sms') {
        this.setState({ 
          sms: 1, 
          push: 0 
        });
      } else if (name === 'push') {
        this.setState({ 
          sms: 0, 
          push: 1 
        });
      }
    } else {
      // Se estiver desmarcando, apenas atualiza o estado atual
      this.setState({ [name]: 0 });
    }
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = () => {
    const { name, sms, push } = this.state;
    insertDmService('/Pedido', {
      id: '0',
      tipoCadastro: { id: '1' },
      descricao: name,
      area: { id: '2' },
      sms: {id: sms},
      push: {id: push}
    })
      .then(data => {
        const { history } = this.props;
        history.push(`/comunicacao/campanha/${data.id}/informacoes`);
      })
      .catch(() => {
        // this.setState({ error });
      });
  };

  render() {
    const { name, sms, push } = this.state;
    
    return (
      <Card>
        <div className="bx--col-md-12">
          <div className="bx--row v-md-margin">
            <div className="bx--col-md-12 mg-top-20">
              <h4 className="new-campaign-title">Criar Nova Campanha</h4>
              <p className="new-campaign-subtitle">
                Preencha um nome para sua campanha.
              </p>
            </div>
          </div>
          <div className="bx--row h-xs-margin">
            <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
              <label className="bx--label">Nome da Campanha</label>
              <input
                id="text-input-3"
                type="text"
                className="bx--text-input"
                required
                placeholder="Ex.: Engajamento"
                name="name"
                value={name}
                onChange={this.onChangeText}
              />
            </div>
            
            {/* Opção 1: Usando Checkboxes com lógica de exclusão mútua */}
            <div className="bx--col-md-12">
              <p className="bx--label">Tipo de Mensagem</p>
              <div className="message-type-selection">
                <Checkbox
                  className="check-uniq"
                  labelText="SMS"
                  id="sms"
                  name="sms"
                  checked={sms === 1}
                  onChange={this.onChangeCheck}
                />
                <Checkbox
                  className="check-uniq"
                  labelText="Push"
                  id="push"
                  name="push"
                  checked={push === 1}
                  onChange={this.onChangeCheck}
                />
              </div>
              
              {/* Descrições dos tipos de mensagem */}
              {sms === 1 && (
                <div className="type-description">
                  <p className="bx--form-helper-text">
                    SMS: Limite de 160 caracteres. Não permite emojis ou caracteres especiais.
                  </p>
                </div>
              )}
              
              {push === 1 && (
                <div className="type-description">
                  <p className="bx--form-helper-text">
                    Push: Título de até 50 caracteres e corpo de 100-120 caracteres. Permite emojis.
                  </p>
                </div>
              )}
            </div>
            
            {/* Alternativa: Usando RadioButtonGroup para melhor semântica */}
            {/* 
            <div className="bx--col-md-12">
              <RadioButtonGroup
                name="message-type"
                onChange={(value) => {
                  if (value === 'sms') {
                    this.setState({ sms: 1, push: 0 });
                  } else {
                    this.setState({ sms: 0, push: 1 });
                  }
                }}
                valueSelected={sms === 1 ? 'sms' : (push === 1 ? 'push' : null)}
                legend="Tipo de Mensagem"
              >
                <RadioButton
                  id="sms-option"
                  labelText="SMS"
                  value="sms"
                />
                <RadioButton
                  id="push-option"
                  labelText="Push"
                  value="push"
                />
              </RadioButtonGroup>
              
              {sms === 1 && (
                <div className="type-description">
                  <p className="bx--form-helper-text">
                    SMS: Limite de 160 caracteres. Não permite emojis ou caracteres especiais.
                  </p>
                </div>
              )}
              
              {push === 1 && (
                <div className="type-description">
                  <p className="bx--form-helper-text">
                    Push: Título de até 50 caracteres e corpo de 100-120 caracteres. Permite emojis.
                  </p>
                </div>
              )}
            </div>
            */}
            
            <div className="bx--col-md-12">
              <button
                className="bx--btn btn-secondary-color v-md-margin"
                disabled={!name || (sms === 0 && push === 0)}
                type="submit"
                onClick={() => this.handleSubmit()}
              >
                Começar
              </button>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

export default withRouter(NewCampaign);



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/NewCampaign.js